import {
    Alert,
    Button,
    FormControl,
    FormLabel,
    Modal,
    ModalClose,
    ModalDialog,
    Stack,
    Textarea,
    Typography,
} from "@mui/joy";
import { useContext, useState, useEffect } from "react";
import { LayoutContext } from "../../context";
import { APIToggleBlockProfile } from "../../api";
import { BlockRounded } from "@mui/icons-material";

/**
 * Окно блокировки профиля с обязательной причиной.
 * Использование:
 *   <ModalBlockProfile
 *     open={open}
 *     profile={{ id, name, type_profile }}
 *     onClose={() => setOpen(false)}
 *     onBlocked={(response) => {...}}   // вызывается после успешной блокировки
 *   />
 */
export default function ModalBlockProfile({ open, profile, onClose, onBlocked }) {
    const { token } = useContext(LayoutContext);

    const [reason, setReason] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (open) {
            setReason('');
            setError(null);
        }
    }, [open]);

    if (!open || !profile) return null;

    const handleSubmit = async () => {
        if (!reason.trim()) {
            setError('Укажите причину блокировки — это важно для модерации.');
            return;
        }
        try {
            setSaving(true);
            setError(null);
            const profileType = Array.isArray(profile.type_profile)
                ? profile.type_profile[0]
                : (profile.type_profile || 'patient');
            const response = await APIToggleBlockProfile(token, profile.id, profileType, reason.trim());
            if (response?.success) {
                onBlocked?.(response);
                onClose?.();
            } else {
                setError(response?.error || 'Не удалось заблокировать профиль');
            }
        } catch (e) {
            setError(e?.response?.data?.error || 'Ошибка при блокировке');
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose} sx={{ zIndex: 10011 }}>
            <ModalDialog size="md" sx={{ maxWidth: 500, width: '95%' }}>
                <ModalClose onClick={onClose} />
                <Typography level="h4" startDecorator={<BlockRounded color="danger" />} sx={{ mb: 1 }}>
                    Блокировка профиля
                </Typography>
                <Typography level="body-sm" color="neutral" sx={{ mb: 2 }}>
                    Профиль: <b>{profile.name}</b>
                </Typography>

                {error && <Alert color="danger" sx={{ mb: 2 }}>{error}</Alert>}

                <Stack spacing={2}>
                    <FormControl required>
                        <FormLabel>Причина блокировки</FormLabel>
                        <Textarea
                            minRows={3}
                            placeholder="Например: грубость в адрес сотрудников, спам, нарушение правил…"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </FormControl>

                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                        <Button variant="plain" color="neutral" onClick={onClose} disabled={saving}>
                            Отмена
                        </Button>
                        <Button color="danger" loading={saving} onClick={handleSubmit}>
                            Заблокировать
                        </Button>
                    </Stack>
                </Stack>
            </ModalDialog>
        </Modal>
    );
}
